import 'source-map-support/register';

/**
 * Gives the base configuration.
 *
 * @returns {object} Returns the base configuration
 */
export const baseConfig = require('../config/roc.config.js');

/**
 * Gives the meta configuration.
 *
 * @returns {object} Returns the meta configuration
 */
export const metaConfig = require('../config/roc.config.meta.js');
